import { Link } from 'react-router-dom';

// Calm Quiet Board state icon: a muted Lucide-style line glyph in a sunken circle.
// Replaces the "Goldie" trophy mascot — the design system uses no mascots/trophies.
function StateIcon({ children, tone = 'muted' }) {
  const color = tone === 'caution' ? 'text-night-busy-text' : 'text-ink-secondary';
  return (
    <div className={`w-14 h-14 rounded-full bg-surface-sunken ${color} flex items-center justify-center mb-4`}>
      <svg viewBox="0 0 24 24" className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
      </svg>
    </div>
  );
}

const UtensilsIcon = (
  <>
    <path d="M3 2v7c0 1.1.9 2 2 2h0a2 2 0 0 0 2-2V2" />
    <path d="M7 2v20" />
    <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
  </>
);

const AlertIcon = (
  <>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </>
);

export function LoadingSpinner({ message = 'Loading…' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-3">
      <div className="w-8 h-8 border-2 border-hairline border-t-primary rounded-full animate-spin" />
      <p className="font-body text-sm text-ink-soft">{message}</p>
    </div>
  );
}

export function EmptyState({ emoji, mascot, title, description, action, onAction, to }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {mascot ? (
        <StateIcon>{UtensilsIcon}</StateIcon>
      ) : emoji ? (
        <span className="text-5xl mb-4">{emoji}</span>
      ) : null}
      <p className="font-display text-lg font-semibold text-ink mb-1">{title}</p>
      {description && <p className="font-body text-sm text-ink-muted max-w-[280px] mb-5">{description}</p>}
      {action && to && (
        <Link to={to} className="px-6 py-2.5 rounded-xl bg-primary text-ink-inverse hover:bg-primary-hover font-body font-medium text-sm transition-colors">{action}</Link>
      )}
      {action && onAction && !to && (
        <button type="button" onClick={onAction} className="px-6 py-2.5 rounded-xl bg-primary text-ink-inverse hover:bg-primary-hover font-body font-medium text-sm transition-colors">{action}</button>
      )}
    </div>
  );
}

export function ErrorState({ message = 'Something went wrong', onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <StateIcon tone="caution">{AlertIcon}</StateIcon>
      <p className="font-display text-lg font-semibold text-ink mb-1">Something went wrong</p>
      <p className="font-body text-sm text-ink-soft max-w-[280px] mb-5">{message || "Couldn't load that. Try again."}</p>
      {onRetry && (
        <button type="button" onClick={onRetry} className="px-6 py-2.5 rounded-xl bg-primary text-ink-inverse hover:bg-primary-hover font-body font-medium text-sm transition-colors">Try again</button>
      )}
    </div>
  );
}
